import { useGlobalStore } from "../store/globalStore";
import {
  fetchOptions,
  fetchPurposes,
  fetchReferenceData,
} from "../client_onboarding/ClientsGrid/ClientsGrid.service";
import { fetchAllUsers } from "../client_onboarding/ApproverSettingModal/ApproverSettingModal.service";

/**
 * Initializes and stores all global lookup/reference data after login.
 * Checks Zustand store first to avoid unnecessary re-fetch on reload.
 */
export const initializeClientGlobalOptions = async () => {
  const { setGlobalOptions } = useGlobalStore.getState();

  const [
    purposes,
    partners,
    officeLocations,
    usersData,
    clientTypesData,
    clientStatusData,
  ] = await Promise.all([
    fetchPurposes(),
    fetchOptions("get_staff_cch"),
    fetchOptions("get_client_office_cch"),
    fetchAllUsers(() => {}),
    fetchReferenceData("ClientType"),
    fetchReferenceData("ClientStatus"),
  ]);

  setGlobalOptions({
    purposeOptions: purposes,
    primaryPartnerOptions: partners,
    officeLocationOptions: officeLocations,
    users: usersData,
    clientTypes: clientTypesData,
    clientStatus: clientStatusData,
  });
};

export const initializeELGlobalOptions = async () => {
  const { setGlobalOptions } = useGlobalStore.getState();

  const [
    elStatusData,
    elApprovalStatusData,
    elSignatureStatusData,
  ] = await Promise.all([
    fetchReferenceData("EngagementLetterStatus"),
    fetchReferenceData("EngagementLetterApprovalStatus"),
    fetchReferenceData("EngagementLetterSignatureStatus"),
  ]);

  setGlobalOptions({
    elStatus: elStatusData,
    elApprovalStatus: elApprovalStatusData,
    elSignatureStatus: elSignatureStatusData,
  });
};